module.exports = __webpack_public_path__ + "static/media/af_lab_odkryj_techniki_2.9641b89f.mp4";